import {
  getSfpAddress,
  getSushiAddress,
  getPetAddress,
  getPokerAddress,
  getCarAddress,
  getDoggyAddress,
  getSoccerAddress,
  getBarkAddress,
  getRacaAddress,
  getDogeAddress,
  getBusdAddress,
  getTokauAddress
} from '../sushi/utils'

import { SUPPORTTYPE } from '../constants/bakery/nft'

export function userTokenName(sushi: any, tokenAddress?: string) {
  let tokenName = SUPPORTTYPE.BAKE
  switch (tokenAddress && tokenAddress.toLowerCase()) {
    case getSushiAddress(sushi) && getSushiAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.BAKE
      break
    case getPetAddress(sushi) && getPetAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.PET
      break
    case getPokerAddress(sushi) && getPokerAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.POKER
      break
    case getSfpAddress(sushi) && getSfpAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.SFP
      break
    case getCarAddress(sushi) && getCarAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.CAR
      break
    case getDoggyAddress(sushi) && getDoggyAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.DOGGY
      break
    case getSoccerAddress(sushi) && getSoccerAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.SOCCER
      break
    case getBarkAddress(sushi) && getBarkAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.BARK
      break
    case getRacaAddress(sushi) && getRacaAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.RACA
      break
    case getDogeAddress(sushi) && getDogeAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.DOGE
      break
    case getBusdAddress(sushi) && getBusdAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.BUSD
      break
    case getTokauAddress(sushi) && getTokauAddress(sushi).toLowerCase():
      tokenName = SUPPORTTYPE.TOKAU
      break
  }
  return tokenName
}
